export enum SESSION_KEYS {
  IS_INITIALIZED = '@session/isInitialized',
  IS_LOGGED_IN = '@session/isLoggedIn',
  IS_THEME_REQUESTED = '@session/themeRequested',
  SESSION = '@session/currentSession',
  TOKEN = '@session/token',
}

export const LAST_ACTIVITY_STORAGE_KEY = 'lastActivity';

export const SESSION_CONFIG = {
  ACTIVITY_THROTTLE: 1000, // min interval between last-activity writes (milliseconds)
  EXPIRATION_OFFSET: 15 * 1000, // the offset before the expiration of the token for
  IDLE_TICK: 1000, // how often each tab checks the shared last-activity time
  IDLE_TIMEOUT: 15 * 60 * 1000, // inactivity before logout, PCI DSS 8.2.8
  IDLE_WARNING: 60 * 1000, // how long before the idle logout the warning is shown
  INTERVAL_OFFSET: 2 * 60 * 1000, // the offset before the expiration of the token for the ticker to try to refresh
  PENDING_TICKER_STEP: 50, // the frequency of checkout for the pending refresh to be finished,
  PENDING_TIMEOUT: 30 * 1000, // the timeout for the pending request to wait for the current token refresh that is already in proggress
  // the outcoming request to consider the token invalid (milliseconds)
  RETRIES_LOGGED_IN: 1, // how many times the refresh request will retry if the user logged in
  RETRIES_LOGGED_OUT: 0, // how many times the refresh request will retry if the user logged out
} as const;
